import React, { Component } from 'react';
import classes from './InformationEditor.module.css';
import AdminSettings from '../Controls/AdminSettings';

class InformationEditor extends Component {

    state = {
        showPhonenumber: false,
        showStreamUrl: false
    }

    showPhonenumber = () => {
        this.setState(prev => ({ showPhonenumber: !prev.showPhonenumber }));
    }

    showStreamUrl = () => {
        this.setState(prev => ({ showStreamUrl: !prev.showStreamUrl }));
    }

    render(){
        return(
            <div>
                <div className={classes.wrapper}>
                    <h1>Muokkaa tietoja</h1>
                    <AdminSettings show={this.state.showPhonenumber} click={this.showPhonenumber} functionality='Studion numero' setting='phonenumber' onSuccess={this.props.onSuccess}/>
                    <AdminSettings show={this.state.showStreamUrl} click={this.showStreamUrl} functionality='Stream URL' setting='streamUrl' onSuccess={this.props.onSuccess}/>
                </div>
            </div>
        );
    }
}

export default InformationEditor;